import './media.js';
import './slideshow.js';
import './layered-slideshow.js';
import './video-background.js';

(function initDeferredVideos() {
  function activateVideos() {
    const videoElements = document.querySelectorAll('.slide__video, .hero__media, .layered-slideshow__video');
    videoElements.forEach((video) => {
      let needsLoad = false;
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach((source) => {
        if (source.dataset.src) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          needsLoad = true;
        }
      });
      if (video.dataset.src) {
        video.src = video.dataset.src;
        video.removeAttribute('data-src');
        needsLoad = true;
      }
      if (needsLoad) {
        video.load();
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      }
    });
  }

  if (document.readyState === 'complete') {
    setTimeout(activateVideos, 400);
  } else {
    window.addEventListener('load', function() {
      setTimeout(activateVideos, 400);
    });
  }
})();
